import React from 'react';

import { CssBaseline, AppBar, Toolbar } from '@material-ui/core';

import Logo from './Logo';
import Menu from './Menu';

import './Header.css';

const Header = () => (
  <div id="header-top" className="header-top">
    <CssBaseline />
    <AppBar position="fixed" style={{ zIndex: '9999' }}>
      <Toolbar>
        <Logo />
        <Menu />
      </Toolbar>
    </AppBar>
  </div>
);

export default Header;
